/** Removes authentication hints before query parameters are retained or reported. */
import { LocationQuery } from 'vue-router';

export const LOGIN_HINT_QUERY_PARAM = 'login_hint';
export const AGENCY_HINT_QUERY_PARAM = 'agency_hint';

const AGENCY_HINT_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

/** Returns a scalar string query value, or `undefined` for missing/non-string values. */
export function getStringQueryParam(
  query: Record<string, unknown>,
  key: string,
): string | undefined {
  const value = query[key];
  return typeof value === 'string' ? value : undefined;
}

/** Builds the Auth0 authorization parameters supported by the login redirect. */
export function buildAuthLoginAuthorizationParams(
  locale: string,
  query: Record<string, unknown>,
): Record<string, string> {
  const authorizationParams: Record<string, string> = {
    ui_locales: locale,
  };

  const loginHint = getStringQueryParam(query, LOGIN_HINT_QUERY_PARAM);
  if (loginHint) {
    authorizationParams[LOGIN_HINT_QUERY_PARAM] = loginHint;
  }

  return authorizationParams;
}

/** Returns a validated agency identifier, rejecting values unsafe for API path interpolation. */
export function getAgencyHintQueryParam(query: Record<string, unknown>): string | undefined {
  const agencyHint = getStringQueryParam(query, AGENCY_HINT_QUERY_PARAM);
  if (agencyHint && AGENCY_HINT_PATTERN.test(agencyHint)) {
    return agencyHint;
  }

  return undefined;
}

export function stripLoginHintQueryParams(query: LocationQuery): LocationQuery {
  const {
    [LOGIN_HINT_QUERY_PARAM]: _loginHint,
    [AGENCY_HINT_QUERY_PARAM]: _agencyHint,
    ...remainingQuery
  } = query;

  return remainingQuery;
}
